import * as bootstrap from 'bootstrap'
import jQuery from 'jquery'

jQuery(function($) {
  //scroll to top
  $(window).on('scroll', (function(){
    if ($(this).scrollTop() < 200) {
      $('#back-to-top') .fadeOut();
    } else {
      $('#back-to-top') .fadeIn();
    }
  }));

  // back to top
  $('#back-to-top').on("click", function(){
    $('html, body').animate({scrollTop:0}, 'fast');
    return false;
  });


  function normalizePath(path) {
    return (path || '/')
      .replace(/\/+$/, '')
      .replace(/^\//, '');
  }
  // smooth scrolling for anchor links, also when they use an absolute URL to the current page
	$('a[href*="#"]:not([href$="#"])').on("click", function(event) {
    var url = new URL(this.href, window.location.origin);
    var isSamePage = window.location.origin === url.origin &&
      normalizePath(window.location.pathname) === normalizePath(url.pathname) &&
      window.location.search === url.search;

    if (isSamePage && url.hash) {
      var targetElement = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      var target = $(targetElement);

      if (target.length) {
        event.preventDefault();
        $('html, body').stop().animate({
          scrollTop: target.offset().top - 78
        }, 1000);
      }
    }
	});

  $('a').each(function() {
    var a = new RegExp('/' + window.location.host + '/');
    if(!a.test(this.href)) {
      $(this).on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(this.href, '_blank');
      });
    }
  });

  // open all external links in a new tab, except those with target attribute set
  /*var links = document.querySelectorAll('a');
  [].forEach.call(links, function(link) {
    var a = new RegExp('/' + window.location.host + '/');
    if(!a.test(link.href) && !link.target) {
      // console.log(link.href);
      link.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(link.href, '_blank');
      });
    }
  });  */
})
